/**
 * Utility functions
 */

const RE_REGEX_CHAR = /[\\^$.*+?()[\]{}|]/g;

/**
 * Determine if application is in Experience Editor mode. 
 * 
 * @returns {Boolean}
 */
export const isExperienceEditorMode = () => {
  return typeof window.Sitecore !== 'undefined' && typeof window.Sitecore.WebEditSettings !== 'undefined' && window.Sitecore.WebEditSettings.editing;
};

export const focusableChildren = (element) => {
  var focusables = [
    'a',
    'button',
    'input',
    'textarea',
    'select',
    'details',
    '[tabindex]',
    '[contenteditable="true"]'
  ].map(function (selector) {
    return selector + ':not([tabindex^="-"])';
  }).join(', ');

  if (!element) {
    element = document.body;
  }
  else if (typeof element === 'object' && element.jquery) {
    element = element[0];
  }
  else if (typeof jQuery !== 'undefined') {
    element = jQuery(element);
    if (element.length) {
      element = element[0];
    }
    else {
      return [];
    }
  }

  if (typeof element.querySelectorAll !== 'function') {
    return [];
  }


  return [...element.querySelectorAll(focusables)].filter(elem => {
    if (elem.getAttribute('disabled') === null && !elem.classList.contains('disabled') && elem.style['display'] !== 'none' && elem.getClientRects().length > 0) {
      return true;
    }

    return false;
  });
};

export const focusableChildrenAll = (element) => {
  var focusables = [
    'a',
    'button',
    'input',
    'textarea',
    'select',
    'details',
    '[tabindex]',
    '[contenteditable="true"]'
  ].join(', ');

  if (!element) {
    element = document.body;
  }
  else if (typeof element === 'object' && element.jquery) {
    element = element[0];
  }
  else if (typeof jQuery !== 'undefined') {
    element = jQuery(element);
    if (element.length) {
      element = element[0];
    }
    else {
      return [];
    }
  }

  if (typeof element.querySelectorAll !== 'function') {
    return [];
  }

  return [...element.querySelectorAll(focusables)];
};

/**
 * A simple debounce util
 * 
 * @param {Function} cb 
 * @param {Integer} threshold 
 * @returns {Function}
 */
export const debounce = (cb, threshold = 200) => {
  let timerId;
  let cbArgs = null;

  function clearTimer() {
    if (timerId) {
      window.clearTimeout(timerId);
      timerId = null;
    }
  }

  function setTimer() {
    clearTimer();
    timerId = window.setTimeout(runIt, threshold);
  }

  function runIt() {
    clearTimer();
    cb.apply(null, cbArgs);
  }

  function debounced(...args) {
    cbArgs = args;
    setTimer();
  }

  debounced.cancel = () => {
    clearTimer();
  };

  return debounced;
};


/**
 * Whether or not a object has the specified property as its own property.
 * 
 * @param {Object} obj
 * @param {String} prop
 * @return {Boolean}
 */
export const objectHasOwnProperty = (obj, prop) => {
  return Object.prototype.hasOwnProperty.call(obj, prop);
};

export default {
  /**
   * A simple debounce util
   * 
   * @param {Function} cb 
   * @param {Integer} threshold 
   * @returns {Function}
   */
  debounce: (cb, threshold = 200) => {
    let timerId;
    let cbArgs = null;

    function clearTimer() {
      if (timerId) {
        window.clearTimeout(timerId);
        timerId = null;
      }
    }

    function setTimer() {
      clearTimer();
      timerId = window.setTimeout(runIt, threshold);
    }

    function runIt() {
      clearTimer();
      cb.apply(null, cbArgs);
    }

    function debounced(...args) {
      cbArgs = args;
      setTimer();
    }

    debounced.cancel = () => {
      clearTimer();
    };

    return debounced;
  },

  animationFrame: (cb) => {
    let timerId;
    let cbArgs = null;

    function clearTimer() {
      if (timerId) {
        window.cancelAnimationFrame(timerId);
        timerId = null;
      }
    }

    function setTimer() {
      clearTimer();
      timerId = window.requestAnimationFrame(runIt);
    }

    function runIt() {
      clearTimer();
      cb.apply(null, cbArgs);
    }

    function debounced(...args) {
      cbArgs = args;
      setTimer();
    }

    return debounced;
  },

  /**
   * Remove duplication from and return as new array.
   * 
   * @param {Array} arr 
   * @returns {Array}
   */
  uniqueArray: (arr) => {
    return arr.filter(function (el, index, arr) {
      return index === arr.indexOf(el);
    });
  },

  reRegexChar: RE_REGEX_CHAR,

  escapeRegex: str => str.replace(RE_REGEX_CHAR, '\\$&'),

  /**
   * Group array items into a array of specified chunk size.
   * 
   * @param {Array} arr 
   * @param {Integer} size Chunk size, must be integer value greater then 1.
   * @return {Array}
   */
  chunkArray: (arr, size) => {
    try {
      size = Math.floor(Number(size));
    }
    catch (err) {
      size = 0;
    }

    if (size && size > 1) {
      const res = [];
      for (let i = 0; i < arr.length; i += size) {
        const chunk = arr.slice(i, i + size);
        res.push(chunk);
      }
      return res;
    }

    return arr;
  },

  focusableChildren: focusableChildren,

  focusableChildrenAll: focusableChildrenAll,

  isExperienceEditorMode: isExperienceEditorMode,

  objectHasOwnProperty: objectHasOwnProperty
};